import { gql } from "@apollo/client";

export const updateTargetBadge = gql`
  mutation UpdateTargetBadge($badge: TargetBadgeInput!, $targetBadgeId: ID) {
    updateTargetBadge(badge: $badge, target_badge_id: $targetBadgeId)
  }
`;

export const deleteTargetBadge = gql`
  mutation DeleteTargetBadge($target_badge_id: ID!) {
    deleteTargetBadge(target_badge_id: $target_badge_id)
  }
`;
